'use strict';

module.exports = /* @ngInject */ ["$q", "authApiFactory", "eikonSsoService", function ($q,
                                           authApiFactory,
                                           eikonSsoService) {
  var that = this;
  var ssoCookiePromise;

  that.getGoldmanSsoCookie = function () {
    if (!ssoCookiePromise) {
      ssoCookiePromise = eikonSsoService.getEikonToken()
          .then(function(eikonCookieToken) {
            return getCookiesFromServer(eikonCookieToken);
          });
    }
    return ssoCookiePromise;
  };


  function getCookiesFromServer(eikonCookieToken) {
    return authApiFactory.create().then(function (authApi) {
      return authApi.one('gssso')
          .withHttpConfig({ignoreAuthModule: true})
          .get(null, {iPlanetDirectoryPro: eikonCookieToken})
    });
  }

}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/business/goldmanSsoService.js
// module id = 117
// module chunks = 0